import React, { useContext } from 'react';

import { contextHOC } from 'Modules/ui';
import { CloseModalButtonProps } from 'Modules/ui3';

import { ModalComponentProps, ModalContextType } from './types';
import styles from './index.module.scss';


export const ModalContextObject = React.createContext<ModalContextType>({} as ModalContextType);
export const ModalContext = ModalContextObject.Consumer;
export const withModalContext = contextHOC(ModalContext);
export const useModalContext = (): ModalContextType => useContext(ModalContextObject);

export const modalClassNames = {
    title: styles.modalTitle,
    content: styles.modalContent,
    contentDfa: styles.modalContentDfa,
    contentDfaNew: styles.modalContentNominalAccount,
    contentProposalApprovement: styles.modalContentProposalApprovement,
    buttons: styles.modalButtons,
    button: styles.modalButton,
};

export function createModal(modal: ModalComponentProps) {
    return Object.assign(modal, { toString: () => modal.key });
}

export const closeButtonVariants: Record<ModalComponentProps['closeButtonVariant'],
Pick<CloseModalButtonProps, 'variant' | 'size' | 'withBorder'>> = {
    default: {
        size: 'extraSmall',
        variant: 'stroke',
    },
    dfa: {
        size: 'medium',
        variant: 'stroke',
    },
    dfaSmall: {
        size: 'small',
        variant: 'stroke',
    },
    co: {
        size: 'small',
        variant: 'secondary',
        withBorder: true,
    },
};
